export const FREQUENCY_DIET = 'Frequenza giorni';

// The frequency belongs to a day and is repeated on its rows in the existing plan JSON.
export function dietFrequencies(rows = []) {
 const groups = new Map();
 for (const row of rows.filter(row => row?.food?.trim())) {
  const day = Number(row.dayNumber) || 1;
  if (!groups.has(day)) groups.set(day, []);
  groups.get(day).push(row.dayFrequency);
 }
 const days = [...groups].sort(([a], [b]) => a - b).map(([dayNumber, values]) => {
  const frequency = values[0];
  const valid = Number.isInteger(dayNumber) && dayNumber >= 1 && dayNumber <= 7 && Number.isInteger(frequency) && frequency >= 1 && frequency <= 7 && values.every(value => value === frequency);
  return {dayNumber, frequency: valid ? frequency : null};
 });
 const total = days.reduce((sum, day) => sum + (day.frequency || 0), 0);
 const valid = days.length > 0 && days.every(day => day.frequency !== null) && total === 7;
 return {days, total, valid, message: !days.length ? 'Inserisci almeno una giornata con alimenti.' : days.some(day => day.frequency === null) ? 'Indica per ogni giornata quante volte ripeterla: un numero intero da 1 a 7.' : total !== 7 ? `La settimana copre ${total} giorni: il totale deve essere 7.` : 'Settimana completa: 7 giorni.'};
}
